import React, { Component } from "react";
export class SubscriberAgreement extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }
    render() {
        return (
            <React.Fragment>
                <a className="LinkButton" href="https://www.virtualdcs.co.uk/download/CloudCover365-Terms.pdf" target="_blank" style={{ marginRight: "5px" }} rel="noopener noreferrer">CloudCover 365 Terms</a>
            </React.Fragment>
        );
    }
}